/* @flow */
import React from 'react';

import cx from 'classnames';
import './styles/ButtonGroup.scss';

/**
 * A component to display a group a buttons side-by-side.
 *
 * ```example
 *  <ButtonGroup level="primary">
 *    <Button>Fee</Button>
 *    <Button>Fi</Button>
 *    <Button>Fo</Button>
 *    <Button color="lava">Fum</Button>
 *  </ButtonGroup>
 * ```
 */
class ButtonGroup extends React.Component {
  static propTypes = {
    level: React.PropTypes.string,
    color: React.PropTypes.string,
    size: React.PropTypes.string,
    /** A minimum of two buttons are required as children. */
    children(props, propName) {
      if (React.Children.count(props[propName]) <= 1) {
        return new Error('ButtonGroup expects at least two child buttons');
      } else {
        return null;
      }
    },
  };

  render() {
    const { level, color, size, ...others } = this.props;

    const children = React.Children.map(this.props.children, button => {
      return React.cloneElement(button, {
        level: button.props.level || level,
        color: button.props.color || color,
        size: button.props.size || size,
      });
    });

    return (
      <div {...others} className={cx('ButtonGroup', this.props.className)}>
        {children}
      </div>
    );
  }
}

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/ButtonGroup.jsx